export const FONTS = [
  { label: 'Annedemarie', value: 'Annedemarie, system-ui, sans-serif' },
  { label: 'Swipe', value: 'Swipe, system-ui, sans-serif' },
  { label: 'Bubblegum Sans', value: 'Bubblegum Sans, system-ui, sans-serif' },
  { label: 'Caveat Brush', value: 'Caveat Brush, system-ui, sans-serif' },
  { label: 'Chewy', value: 'Chewy, system-ui, sans-serif' },
  { label: 'Chicle', value: 'Chicle, system-ui, sans-serif' },
  { label: 'Joti One', value: 'Joti One, system-ui, sans-serif' },
  { label: 'Knewave', value: 'Knewave, system-ui, sans-serif' },
  { label: 'Poetsen One', value: 'Poetsen One, system-ui, sans-serif' },
  { label: 'Rubik Variable', value: 'Rubik Variable, system-ui, sans-serif' },
  { label: 'Satisfy', value: 'Satisfy, system-ui, sans-serif' },
  { label: 'Poppins', value: 'Poppins, system-ui, sans-serif' },
  { label: 'Inter', value: 'Inter, system-ui, sans-serif' },
  { label: 'Arial Black', value: 'Arial, Helvetica, sans-serif' },
];
